export const appOrigin = (embedUrl) => new URL(embedUrl).origin;

export const attributeValue = (value) => value.replace(/&/g, "&amp;").replace(/"/g, "&quot;");

export const trafficSourceTag = (embedUrl) =>
  `<script src="${appOrigin(embedUrl)}/packs/od_tag.js"></script>`;

export const ticketWidgetTag = (embedUrl, iframeId, title) => {
  return `<script src="${appOrigin(embedUrl)}/packs/od_embed.js"></script>
<iframe src="${embedUrl}" id="${iframeId}" title="${attributeValue(title || "Tickets")}" scrolling="no" allowpaymentrequest="true" allow="payment" style="border:none; width: 1px; min-width: 100%; height: 600px;"></iframe>
<script type="text/javascript">
  ODEmbed("${iframeId}");
</script>`;
};
